import React from 'react';
import { Dialog, DialogContent, DialogTitle } from './ui/dialog';
import { X } from 'lucide-react';

/**
 * Convert a Vimeo or YouTube share URL (or already-embedded player URL)
 * into an autoplay-enabled player embed URL.
 */
const toEmbedUrl = (url) => {
  if (!url) return null;
  // Already an embed URL — just ensure autoplay is set
  if (url.includes('player.vimeo.com') || url.includes('youtube.com/embed')) {
    return url.includes('?') ? `${url}&autoplay=1` : `${url}?autoplay=1`;
  }
  // Vimeo short URL: https://vimeo.com/1184458958
  const vimeoMatch = url.match(/vimeo\.com\/(\d+)/);
  if (vimeoMatch) {
    return `https://player.vimeo.com/video/${vimeoMatch[1]}?autoplay=1&badge=0&autopause=0&player_id=0&app_id=58479`;
  }
  // YouTube watch/share URL
  const ytMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]+)/);
  if (ytMatch) {
    return `https://www.youtube.com/embed/${ytMatch[1]}?autoplay=1`;
  }
  return url;
};

const VideoModal = ({ open, onOpenChange, videoUrl, title = 'Video' }) => {
  const embedUrl = toEmbedUrl(videoUrl);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-5xl p-3 pt-12 bg-blue-300/40 backdrop-blur-md border border-blue-300/50 overflow-hidden rounded-2xl shadow-2xl"
        data-testid="video-modal"
      >
        <DialogTitle className="sr-only">{title}</DialogTitle>
        <button
          type="button"
          onClick={() => onOpenChange(false)}
          aria-label="Close video"
          data-testid="video-modal-close"
          className="absolute top-2 right-2 z-10 w-8 h-8 rounded-full bg-white hover:bg-slate-100 text-slate-900 flex items-center justify-center transition-colors shadow-lg"
        >
          <X className="h-4 w-4" />
        </button>
        {open && embedUrl && (
          <div className="rounded-xl overflow-hidden" style={{ padding: '56.25% 0 0 0', position: 'relative' }}>
            <iframe
              src={embedUrl}
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
              title={title}
            />
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default VideoModal;
